export const unavailableRoutes = [
  {
    path: '/503',
    name: 'unavailable',
    component: () => import(/* webpackChunkName: "notifications" */ './Unavailable.vue')
  },
  { path: '*', redirect: '/503' }
];
